import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import LogoFooter from './LogoFooter';
import {
  Box,
  Typography
} from "@mui/material";
import { night } from 'assets/colors';
import packageJson from '../../../../package.json';


const addStyles = props => {
  const useStyle = makeStyles(theme => ({
    footer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      zIndex: 1
    },
    footerPowered: {
      display: 'flex',
      flexDirection: 'row',
      padding: theme.spacing(1),
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: night[800],
      color: theme.palette.grey[200],
      gap: theme.spacing(1)
    },
    logo: {
      height: '32px'
    }
  }))
  return useStyle;
}

export default function Footer (props) {
  const classes = addStyles(props)();
  const [t] = useTranslation();
  const year = new Date().getFullYear();


  return (
    <Box component='footer' className={classes.footer} >
      <Box className={classes.footerPowered}>
        <Typography
          variant="caption"
        >
          {t('common.components.footer.title')}
        </Typography>

        <a href="https://www.octupus.com/" target="_blank" rel="noopener noreferrer">
          <LogoFooter className={classes.logo}/>
        </a>

        <Typography
          className={classes.description}
          variant="caption"
        >
          {t('common.components.footer.description', { year: year })}
        </Typography>

        <Box sx={{ position: 'absolute', right: 0, pr: 2 }}>
          <Typography variant="subtitle1">{`v ${packageJson.version}`}</Typography>
        </Box>
      </Box>
    </Box>
  );
}
